import { Layout, LayoutProps } from 'react-admin';
import AppBar from '../../molecules/AppBar';
import Menu from '../../molecules/Menu';

export default (props: LayoutProps) => (
  <Layout {...props} appBar={AppBar} menu={Menu} />
);
